import { Navigate } from "react-router-dom";
import { useAuthentication } from "../Authentication/context";
import { getFirstRequestRoute, hasAnyRequestAccess } from "./permissions";

const RequestRedirect = () => {
	const { accessMap, authenticating } = useAuthentication();

	if (authenticating) {
		return null;
	}

	if (hasAnyRequestAccess(accessMap)) {
		return <Navigate to={getFirstRequestRoute(accessMap)} />;
	}

	return <Navigate to="/" />;
};

export default RequestRedirect;
